const state = {
  current_storeinfo: {}, //当前的店铺信息
  current_user: {}, // 当前已登录用户的信息
  current_address: {}, //当前用户已选择的地址信息
  lalamove_list: [], //lalamove服务列表信息
  easyparcel_list: [], //easyparcel物流供应商列表信息
  teleport_list: [],
  delyva_list: [],
  // easyparcel_point_type: '', // 当前已选中的包裹收取方式 上门取包裹、自送包裹物流门店
}
const mutations = {
  SET_CURRENT_STOREINFO: (state, current_storeinfo) => {
    state.current_storeinfo = current_storeinfo || {}
  },
  SET_CURRENT_USER: (state, current_user) => {
    state.current_user = current_user || {}
  },
  SET_CURRENT_ADDRESS: (state, current_address) => {
    state.current_address = current_address || {}
  },
  SET_LALAMOVE_LIST: (state, lalamove_list) => {
    state.lalamove_list = lalamove_list || {}
  },
  SET_SASYPARCEL_LIST: (state, easyparcel_list) => {
    state.easyparcel_list = easyparcel_list || {}
  },
  SET_TELEPORT_LIST: (state, teleport_list) => {
    state.teleport_list = teleport_list || {}
  },
  SET_DELYVA_LIST: (state, delyva_list) => {
    state.delyva_list = delyva_list || {}
  },
}

const actions = {
  settingCurrentStoreInfo ({
    commit
  }, StoreData) {
    commit('SET_CURRENT_STOREINFO', StoreData)
  },
  settingCurrentUserInfo ({
    commit
  }, UserData) {
    commit('SET_CURRENT_USER', UserData)
  },
  settingCurrentAddress({
    commit
  }, AddrData) {
    commit('SET_CURRENT_ADDRESS', AddrData)
  },
  settingLalamoveList({
    commit
  }, lalamove_list) {
    commit('SET_LALAMOVE_LIST', lalamove_list)
  },
  settingEasyparcel({
    commit
  }, easyparcel_list) {
    commit('SET_SASYPARCEL_LIST', easyparcel_list)
  },
  settingTeleport ({
    commit
  }, teleport_list) {
    commit('SET_TELEPORT_LIST', teleport_list)
  },
  settingDelyva ({
    commit
  }, delyva_list) {
    commit('SET_DELYVA_LIST', delyva_list)
  },
}

export default {
  namespaced: true,
  mutations,
  state,
  actions
}